var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 88C70.7107 88 87.5 71.2107 87.5 50.5C87.5 29.7893 70.7107 13 50 13C29.2893 13 12.5 29.7893 12.5 50.5C12.5 71.2107 29.2893 88 50 88Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 47.375H50V69.25H53.125",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2188 36.4375C50.9446 36.4375 52.3438 35.0384 52.3438 33.3125C52.3438 31.5866 50.9446 30.1875 49.2188 30.1875C47.4929 30.1875 46.0938 31.5866 46.0938 33.3125C46.0938 35.0384 47.4929 36.4375 49.2188 36.4375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.0debfc82d4cf71c48b6ad04272094ffb.svg";
export { ForwardRef as ReactComponent };